const PROFILE_OPTIONS = [
  { value: 1, name: "Custom uprights" },
  { value: 2, name: "Option1 - 80mm uprights, 1.8mmThk" },
  { value: 3, name: "Option1 - 80mm uprights, Standard 2.0mmThk" },
  { value: 4, name: "Option1 - 80mm uprights, 2.3mmThk" },
  { value: 5, name: "Option2 - 80mm uprights, 1.8mmThk" },
  { value: 6, name: "Option2 - 80mm uprights, 2.0mmThk" },
  { value: 7, name: "Option2 - 80mm uprights, 2.3mmThk" },
  { value: 8, name: "Option3 - 80mm uprights, 1.8mmThk" },
  { value: 9, name: "Option3 - 80mm uprights, 2.0mmThk" },
  { value: 10, name: "Option3 - 80mm uprights, 2.3mmThk" },
  { value: 11, name: "Option1 - 100mm uprights, Standard 2.0mmThk" },
  { value: 12, name: "Option1 - 100mm uprights, 2.5mmThk" },
  { value: 13, name: "Option1 - 120mm uprights, 2.5mmThk" },
  { value: 14, name: "Option2 - 100mm uprights, Standard 2.0mmThk" },
  { value: 15, name: "Option2 - 100mm uprights, 2.5mmThk" },
  { value: 16, name: "Option2 - 120mm uprights, 2.5mmThk" },
  { value: 17, name: "Option3 - 100mm uprights, Standard 2.0mmThk" },
  { value: 18, name: "Option3 - 100mm uprights, 2.5mmThk" },
  { value: 19, name: "Option3 - 120mm uprights, 2.5mmThk" },
  {
    value: 20,
    name: "Sperrin - 80mm uprights, MK2, 2.3mm Thk",
  },
  {
    value: 21,
    name: "NEW - Option1 - 100mm MK3 uprights - 2.0mm THK",
  },
  {
    value: 22,
    name: "NEW - Option1 - 100mm MK3 uprights - 2.5mm THK",
  },
  {
    value: 23,
    name: "NEW - Option1 - 120mm MK3 uprights - 2.0mm THK",
  },
  {
    value: 24,
    name: "NEW - Option1 - 120mm MK3 uprights - 2.5mm THK",
  },
  { value: 25, name: "Option 1 - 140mm MK3 uprights - 2.5mmTHK" },
  { value: 26, name: "Option 1 - 160mm MK3 uprights - 2.5mmTHK" },
];

const profileMenuOptions = [
  { value: 1, label: "All" },
  { value: 2, label: "Option 1" },
  { value: 3, label: "Option 2" },
];

const RESULT_HEADER_MAP = [
  { key: "profileName", label: "Uprights" },
  { key: "text40", label: "Depth Structure" },
  { key: "text45", label: "Gap Between Frames" },
  { key: "text46", label: "Number Frames" },
  { key: "text42", label: "Width Frames" },
  { key: "text50", label: "Number APR" },
  { key: "text51", label: "Width APR" },
  { key: "text47", label: "Number BIP" },
  { key: "text43", label: "Height Frames" },
  { key: "text49", label: "% Load Used At Base" },
  { key: "text44", label: "% Side Load" },
  { key: "text60", label: "FOS" },
];

export { PROFILE_OPTIONS, profileMenuOptions, RESULT_HEADER_MAP };
